import { normalizeMatterRestriction } from "./matter-search";

// XPEN-3758: "only"/"except" with no Matter chosen; the server refuses it too.
const isEmptyMatterRule = (rule) => normalizeMatterRestriction(rule)?.matter_numbers.length === 0;

/**
 * Client-side validation for the create/edit imputation modal on the configuration page.
 */
export function getImputationModalValidationErrors(readLabel, { updatedImputation, isParentMode, subcategories, imputationCatalog }) {
    const nextErrors = [];
    const categoryTrimmed = String(updatedImputation.category ?? "").trim();
    if (!categoryTrimmed) {
        nextErrors.push(readLabel("imputation_validation_category_required", "Please enter a category name."));
    }
    if (isParentMode && subcategories.length > 0) {
        const hasEmptySubName = subcategories.some((s) => !String(s.category ?? "").trim());
        if (hasEmptySubName) {
            nextErrors.push(readLabel(
                "imputation_validation_subcategory_name_required",
                "Please enter a name for every sub-category."
            ));
        }
    }
    // Only the rules on screen: a travel type has no Matters field. In parent
    // mode both the category's field and each subcategory's are shown (XPEN-3781).
    const hasEmptyMatterRule = imputationCatalog !== "displacement" && (
        isEmptyMatterRule(updatedImputation.matter_restriction)
        || (isParentMode && subcategories.some((s) => isEmptyMatterRule(s.matter_restriction))));
    if (hasEmptyMatterRule) {
        nextErrors.push(readLabel(
            "imputation_validation_matter_restriction_empty",
            "Choose at least one Matter, or set the rule to All Matters."
        ));
    }
    return nextErrors;
}
